import { SET_TOTAL_CART_ITEMS } from "../../actions/action.types";

const totalCartItems = (state = 0, action: any) => {
  if (action.type === SET_TOTAL_CART_ITEMS) return action.payload;
  else return state;
};

export default totalCartItems;
